import React from 'react';
import { motion } from 'framer-motion';
interface MiniDonutChartProps {
  percentage: number;
}
export const MiniDonutChart: React.FC<MiniDonutChartProps> = ({
  percentage
}) => {
  const radius = 24;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - percentage / 100);
  return <div className="relative inline-flex items-center justify-center w-16 h-16" data-id="element-286" data-mp="3iuw5r31wget">
      <svg className="w-full h-full transform -rotate-90" data-id="element-287" data-mp="3lxvnomgn9aft">
        <circle cx="32" cy="32" r={radius} stroke="#E5E7EB" strokeWidth="4" fill="none" data-id="element-288" data-mp="3lwc68sj94tcg" />
        <motion.circle cx="32" cy="32" r={radius} stroke="#D1005D" strokeWidth="4" fill="none" initial={{
        strokeDasharray: circumference,
        strokeDashoffset: circumference
      }} animate={{
        strokeDashoffset
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-289" data-mp="3qqymb90a3a2v" />
      </svg>
      <span className="absolute text-sm font-medium text-[#141617]" data-id="element-290" data-mp="37ye4qnq14red">
        {percentage.toFixed(1)}%
      </span>
    </div>;
};